import { Parser } from '@json2csv/plainjs';

export const downloadCSV = (data, fields, filename) => {
  try {
    const opts = { fields, delimiter: ';' }; // Vi bruger semikolon, da Excel i DK foretrækker det
    const parser = new Parser(opts);
    const csv = parser.parse(data);

    // Opret en Blob (fil i hukommelsen)
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    
    // Lav et usynligt download link og klik på det
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error('Fejl ved generering af CSV', err);
    alert('Kunne ikke downloade filen.');
  }
};